import { openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = ["title", "onClick", "aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createElementBlock("div", {
      class: "modal-consulte-bg",
      key: _ctx.refreshCounter
    })),
    (_openBlock(), _createElementBlock("div", {
      ref: "dialogRef",
      class: "modal fade show",
      tabindex: "-1",
      role: "dialog",
      key: _ctx.refreshCounter,
      "aria-labelledby": _ctx.idTitulo,
      "aria-modal": "true",
      style: {"display":"unset","border-radius":"var(--ct-modal-inner-border-radius)"},
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["esc"])),
        _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.manterFocoDentro && _ctx.manterFocoDentro(...args)))
      ]
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              _createElementVNode("h4", {
                class: "modal-title",
                id: _ctx.idTitulo
              }, _toDisplayString(_ctx.titulo), 9, _hoisted_5)
            ], true),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
              "aria-label": "Fechar"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_ConsulteGrid, {
              columns: _ctx.rows,
              "data-source": _ctx.dataSource,
              actions: true,
              onlySearchHeader: false,
              useColumnSort: true
            }, {
              header: _withCtx(() => [...(_cache[3] || (_cache[3] = []))]),
              botaoSelecionar: _withCtx((context) => [
                _createElementVNode("button", {
                  type: "button",
                  title: `Selecionar ${context.row.nome}`,
                  onClick: ($event: any) => (_ctx.selecionarRegistro(context.row)),
                  class: "btn btn-link p-0 border-0 align-baseline font-18 text-success me-2",
                  style: {"margin-right":"5px"},
                  "aria-label": `Selecionar ${context.row.nome}`
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", {
                    class: "uil-arrow-right",
                    "aria-hidden": "true"
                  }, null, -1)
                ]))], 8, _hoisted_7)
              ]),
              _: 1
            }, 8, ["columns", "data-source"])
          ])
        ])
      ])
    ], 40, _hoisted_1))
  ], 64))
}